import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/sharp-solid-svg-icons/faPlus';

import React, { memo, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { Button } from 'ui-components/components/button';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import style from './add-to-batch-menu.module.less';
import BatchListItem from '../../../components/batches/batch-list-item';

const AddToBatchIcon = () => <FontAwesomeIcon className={style['add-icon']} icon={faPlus} />;

const AddToBatchMenuSection = ({
  batch = {},
  handleOrderAddedToBatch,
  handleSelectedBatchItem,
  hasSelection,
  isAddingToBatch,
  isTargetBatch,
  selectedGridFulfillmentPlanIds,
  shouldHighlight,
}) => {
  const onAddToBatchClick = useCallback(() => {
    handleOrderAddedToBatch(batch, selectedGridFulfillmentPlanIds);
  }, [batch, selectedGridFulfillmentPlanIds, handleOrderAddedToBatch]);

  const onBatchItemSelected = useCallback(() => {
    handleSelectedBatchItem(batch);
  }, [batch, handleSelectedBatchItem]);

  const { pathname } = useLocation();
  const { fulfillmentPlanSetId } = batch;
  const pathIncludesFulfillmentPlanSetId = pathname.includes(`batches/open/${fulfillmentPlanSetId}`);
  const hasSelectedGridItems = selectedGridFulfillmentPlanIds.length > 0 || hasSelection;

  const shouldShowAddToBatchButton = hasSelectedGridItems;
  const isSelected = pathIncludesFulfillmentPlanSetId;

  return (
    <div
      className={classnames(style.row, {
        [style['has-selection']]: hasSelection && !pathIncludesFulfillmentPlanSetId,
        [style.selected]: pathIncludesFulfillmentPlanSetId,
      })}
    >
      <div className={style['batch-list-item-wrapper']}>
        <BatchListItem batch={batch} isNavItem onClick={onBatchItemSelected} selected={isSelected} shouldHighlight={shouldHighlight} />
      </div>
      {shouldShowAddToBatchButton ? (
        <Button className={style['add-selection-to-batch-button']} disabled={isAddingToBatch} onClick={onAddToBatchClick} theme='unstyled'>
          {isTargetBatch ? (
            <LoadingIndicator className={style['loading-lighter']} iconClassName={style['loading-icon']} />
          ) : (
            <AddToBatchIcon />
          )}
        </Button>
      ) : null}
    </div>
  );
};

AddToBatchMenuSection.propTypes = {
  batch: PropTypes.object.isRequired,
  handleOrderAddedToBatch: PropTypes.func.isRequired,
  handleSelectedBatchItem: PropTypes.func.isRequired,
  hasSelection: PropTypes.bool.isRequired,
  isAddingToBatch: PropTypes.bool.isRequired,
  isTargetBatch: PropTypes.bool.isRequired,
  selectedGridFulfillmentPlanIds: PropTypes.array.isRequired,
  shouldHighlight: PropTypes.bool.isRequired,
};

export default memo(AddToBatchMenuSection);
